import { render, staticRenderFns } from "./NewDialog.vue?vue&type=template&id=72c948d3&scoped=true&"
import script from "./NewDialog.vue?vue&type=script&lang=js&"
export * from "./NewDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewDialog.vue?vue&type=style&index=0&id=72c948d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c948d3",
  null
  
)

component.options.__file = "NewDialog.vue"
export default component.exports